/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./column.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./column.component";
var styles_ColumnComponent = [i0.styles];
var RenderType_ColumnComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_ColumnComponent, data: {} });
export { RenderType_ColumnComponent as RenderType_ColumnComponent };
export function View_ColumnComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵted(-1, null, ["\n        "])), i1.ɵncd(null, 0), (_l()(), i1.ɵted(-1, null, ["\n    "]))], null, null); }
export function View_ColumnComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ig-col", [], [[8, "className", 0]], null, null, View_ColumnComponent_0, RenderType_ColumnComponent)), i1.ɵdid(1, 638976, null, 0, i2.ColumnComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).className; _ck(_v, 0, 0, currVal_0); }); }
var ColumnComponentNgFactory = i1.ɵccf("ig-col", i2.ColumnComponent, View_ColumnComponent_Host_0, { class: "class", lg: "lg", md: "md", sm: "sm", xs: "xs", lgOffset: "lgOffset", mdOffset: "mdOffset", smOffset: "smOffset", xsOffset: "xsOffset", autoWidth: "autoWidth" }, {}, ["*"]);
export { ColumnComponentNgFactory as ColumnComponentNgFactory };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/grid/column/column.component.ngfactory.js.pre-build-optimizer.js